define('app/views/vue/store/pmsCheckin',['underscore', 'jquery','hbs!app/views/templates/navbar','moment'], function(_, $,navbarTpl,moment) {

    function fetchDataFromCache(modelName, soapCall, params) {
        var dfd = $.Deferred();
        $.when( !app.models[modelName].dataModel[soapCall].data || !app.models[modelName].dataModel[soapCall].data[ app.models[modelName].makeStandardName(app.models[modelName].dataModel[soapCall],params) ] 
                ? app.models[modelName].getData(soapCall, params)
                : app.models[modelName].dataModel[soapCall].data[ app.models[modelName].makeStandardName(app.models[modelName].dataModel[soapCall],params) ] 
        ).then(function(res){
            dfd.resolve(res);
        }).fail(function(err){
            dfd.reject(err);
        });

        return dfd.promise();
    }

    function generateObjectKeyString(sourceObj, str, destinationObj) { // This function modifies the "destinationObj" directly, and hence does not return anything.
        if(sourceObj === null || sourceObj === "") return;

        if(Array.isArray(sourceObj)) {
            sourceObj.forEach(function(obj, index) {
                var newStr = str.concat('[', index, ']');
                if(obj.type || obj.primary) {
                    newStr = newStr.concat(':');
                }
                if(obj.primary) {
                    newStr = newStr.concat('primary=true;');
                }
                if(obj.type){
                    newStr = newStr.concat('type=', obj.type);
                }
                
                generateObjectKeyString(obj, newStr, destinationObj);
            });
            return;
        }
        
        if(typeof sourceObj === 'object') {
            _.keys(sourceObj).forEach(function(key){
                if(["type", "primary"].indexOf(key) > -1 ) return;
                var newStr = str.concat('.', key);
                var objectToSend = sourceObj[key];
                generateObjectKeyString(objectToSend, newStr, destinationObj);
            });
            return;
        }

        destinationObj[str] = sourceObj;
    }



    return {
        namespaced: true,
        strict: true,
        state: {
            eRegOptions: [],
            updatedRegOptions: {},
            existingRegOptions: {},
            customerDetails: {},
            groupMembers: {},
            shareWith: {},
            pmsBookingInfo: {},
            dailyRates: [],
            payEngineDetails: {},
            venueDetails: {},
            showLoader: [],
            arrivalTimes: [],
            estimatedArrival: null,
            showFreedomPayNameField: false
        },
        getters: {
            groupMembers: function(state) {
                return Object.values(state.groupMembers);
            },
            shareWithsAdded: function(state) {
                return Object.keys(state.shareWith).length > 0;
            },
            disableConfirmButton: function(state) {
                return state.customerDetails.Name.FirstName.length === 0 || state.customerDetails.Name.LastName.length === 0 || state.estimatedArrival === null;
            }
        },
        mutations: {
            setEstimatedArrival: function(state, payload) {
                state.estimatedArrival = payload;
            },
            setArrivalTimes: function(state, payload) {
                state.arrivalTimes = payload;
            },
            setShowLoader: function(state, payload) {
                var newState = state.showLoader;
                if(!payload) {
                    newState.pop();
                }else {
                    newState.push(true);
                }

                state.showLoader = newState;
            },
            setVenueDetails: function(state, payload) {
                state.venueDetails = payload;
            },
            setPossibleArrivalTimes:function(state){
                var timesArr = [];
                var pmsBooking = state.pmsBookingInfo
                console.log("444",pmsBooking)
                var arrivalDate = (pmsBooking.ArrivalDate || '').substring(0, 10);
                var startDateTime= moment((arrivalDate+app.customization.roomsBooking.eRegForm.arrivalTimePickerStartTime+'00'), 'YYYY-MM-DDHHmmss');
                var endDateTime= moment((arrivalDate+app.customization.roomsBooking.eRegForm.arrivalTimePickerEndTime+'00'), 'YYYY-MM-DDHHmmss');
                while(startDateTime<= endDateTime) {
                    timesArr.push({value: moment(startDateTime).format('YYYY-MM-DDHHmmss'), text: moment(startDateTime).format('hh:mm a')});
                    startDateTime.add(app.customization.roomsBooking.eRegForm.arrivalTimePickerInterval, 'm')
                }
                state.arrivalTimes = timesArr
            },
            setERegOptions: function(state, payload) {
                state.eRegOptions = payload;
            },
            updateCustomerDetails: function(state, payload) {
                state.customerDetails = payload;
            },
            addGroupMember: function(state, payload) {
                var newState = JSON.parse(JSON.stringify(state.groupMembers));
                newState[payload.CustomerId] = payload;
                state.groupMembers = newState;
            },
            addShareWith: function(state, payload) {
                var newState = Object.assign({}, state.shareWith);
                newState[payload.CustomerId] = _.extend({name: payload.displayName, AllowPosting: 'Y'}, payload);
                state.shareWith = newState;
            },
            removeShareWith: function(state, payload) {
                var newState = _.omit(state.shareWith, payload.CustomerId);
                state.shareWith = newState;
            },
            updateShareWith: function(state, payload) {
                var newState = Object.assign({}, state.shareWith);
                newState[payload.CustomerId] = payload;
                state.shareWith = newState;
            },
            setUpdatedRegOptions: function(state, payload) {
                state.updatedRegOptions = _.extend({}, payload);
            },
            setPayEngineDetails: function(state, payload) {
                state.payEngineDetails = _.extend({}, payload);
            },
            setExistingRegOptions: function(state, payload) {
                state.existingRegOptions = _.extend({}, payload);
            },
            setPmsBooking: function(state, payload) {
                state.pmsBookingInfo = payload;
            },
            setDailyRates: function(state, payload) {
                state.dailyRates = payload;
            },
            toggleFpNameField: function(state, payload) {
                state.showFreedomPayNameField = payload;
                console.log("777",state.showFreedomPayNameField,payload)
            }

        },
        actions: {
            addAlert: function(ctx, payload) {
                ctx.dispatch('alerts/addAlert', payload, {root: true});
            },

            deleteCardOnFile:function(ctx){
                ctx.commit('setShowLoader', true);
                dfd = new Promise(function (resolve, reject) {
                var param = {
                    "Customer.CustomerId": app.data.CustomerId,
                    "Customer.CustomerGUID": app.data.CustomerGUID,
                    "Customer.RemoveOnFileCard": "Y"
                }
                $.when(app.models.systemModel.getData('updateCustomerProfile', param))
                    .done(function (r_fb) {
                        resolve()
                    }).fail(function(r_fb){
                        reject(r_fb.Result.Text)
                    }).always(function(){
                        ctx.commit('setShowLoader', false);
                    })
                })
                return dfd
            },
            logoutOtherUser: function(){
                var dontRedirect = true
                return new Promise(function (resolve, reject) {
                   app.controllers.userController.userLogout('',true)
                    resolve()
                })
               
            },
            updateNavbar: function(){
  
                    //below code is commented as it is not required to reset the navbar ui ref #11142
                      $('#nav').html( navbarTpl( {
                        Customization:app.customization,
                        Localization : app.localization,
                        services : app.data.serviceTypes,
                        languages : app.data.languageNames,
                        siteName : app.localization.siteName,
                        backLink : Customization.serverURL
                    }) );
                    $('#nav a.skip-main').on('click', function (e) {
                        e.preventDefault();
                        $('#main .focus-first').focus();
                    })
                    var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
                        return a.id == app.views.spaView.module
                    }));
                    app.models.systemModel.getData('folioBalance', {}).then(function (folioBalanceData) {
                        app.commonViewHelper.updateNavBar(service, app.language, folioBalanceData);
                    })
            },
            authenticatefolio:function(ctx,params){
                 ctx.commit('setShowLoader', true); 
            
                dfd = new Promise(function (resolve, reject) {
                    var r_l
                    app.models.userModel.getData('authCustomer', { FolioId: params.folioId, LastName: params.lastname.toUpperCase()}
                )
                    .then(function (response) {
                        r_l = response;
                        //login success message
                        app.data.messages.push({ type:'alert', 'class':'alert-success', actions: [],
                            title:app.localization.general.login.loginSuccess,
                            message:''
                        });
                        return app.models.userModel.getData('fetchCustomerProfile', { CustomerId: r_l.CustomerId, CustomerGUID: r_l.CustomerGUID })
                    }, function(){
                        //login fail message
                        app.data.messages.push({
                            type: 'alert', 'class': 'alert-error', actions: [],
                            title: app.localization.general.login.err.invalidCredentials
                        });
                    })
                    .done(function (r_fcp) {
                        app.datac('userLoggedIn', true);
                        app.datac('CustomerId', r_l.CustomerId);
                        app.datac('CustomerGUID', r_l.CustomerGUID);
                        app.datac('FirstName', r_l.FirstName);
                        app.datac('LastName', r_l.LastName);
                        app.datac('folioLoginHasPassword', r_l.HasPassword);
                        app.datac('RestrictedFolio', params.folioId);
                        app.datac('RestrictedLogin', true);
                        app.datac('CustomerEmail', r_fcp.Customer[0].EmailAddress.toLowerCase());
                        if (!app.data.SessionId) {
                            window.location.reload(false);
                            return
                        }
                        $.when(
                            app.models.systemModel.getData('updateSession', { CustomerId: r_l.CustomerId, CustomerGUID: r_l.CustomerGUID }),
                            app.controllers.initController.initGuestItinerary()
                        )
                            .done(function (r_us) {
                                resolve(r_us) 
                            })
                            .fail(function (r_us) {
                                reject(r_us) 
                            }).always(function(){
                                ctx.commit('setShowLoader', false);
                            })
                    })
                    .fail(function (r_l) {
                        reject(r_l) 
                    }).always(function(){
                        ctx.commit('setShowLoader', false);
                    })
                })
                return dfd;
            },
            loadPayEngine: function (ctx,lastname) {             
                var params = {CreateToken: 'Y'}
                ctx.state.payEngineDetails.payEngine == "FP" ? params['ThirdPartyPayEngine'] = 'Google' : ''
                ctx.commit('setShowLoader', true);
                return  app.models.systemModel.getData('setCheckout', params)
                        .then(function (r_sc) {
                            ctx.commit('toggleFpNameField', ctx.state.payEngineDetails.payEngine == 'FP');
                            
                            app.data.loginNextURL = ['summary', 'eReg', [ctx.state.pmsBookingInfo.Venue,ctx.state.pmsBookingInfo.PMSFolioId,lastname]]

                            var errorCheck = app.commonViewHelper.processCardOnFile(r_sc);
                            ctx.commit('setShowLoader', false);

                            if(errorCheck === false) {
                                return new $.Deferred().reject();
                            }

                         },function (r_sc) {
                            ctx.commit('setShowLoader', false);
                            return r_sc.Result.Text;  
                        })
            },
            fetchSystemState: function(ctx){
                app.models.systemModel.fetchSystemState()
                    .done(function (r_fss) {
                        var PaymentEngine = {
                            allowStoreCard : r_fss.Configuration.AllowStoreCard,
                            requiresGuarantee :r_fss.Configuration.RequiresGuarantee,
                            payEngine : r_fss.Configuration.PayEngine,
                            guaranteed : r_fss.Guaranteed
                        }
                        ctx.commit('setPayEngineDetails', PaymentEngine);
                    })
            },
            fetchVenueDetailsAndRegOptions: function(ctx, venue) {
                var optionsObj = {first: []};
                var sortedERegOptions = [];
                var groupedERegOptions = [];
                
                ctx.commit('setShowLoader', true);
                fetchDataFromCache('roomsModel', 'fetchPMSRegOptions', {Venue: venue}).then(function(res) {
                    ctx.commit('setVenueDetails', res.VenueSetup);
                    $.wrapArray(res.ERegOptions.ERegOption).forEach(function(option){
                        console.log("226",option)
                        var key = option.ERegOptionSort || 'first';
                        option.Price = parseFloat(option.Price || 0) > 0 ? res.rawData.CurrencySymbol+option.Price : null;
                        optionsObj[key] = optionsObj[key] || [];
                        optionsObj[key].push(option);
                    });
                    sortedERegOptions = sortedERegOptions.concat(_.sortBy(optionsObj.first, function(option) {return  option.GuestDescription || option.Name}));
                    _.chain(optionsObj).omit('first').keys().sort().each(function(key)  {
                        sortedERegOptions = sortedERegOptions.concat(_.sortBy(optionsObj[key], function(option) {return option.GuestDescription || option.Name}));
                    });
                  
                    var temp = [];
                    sortedERegOptions.forEach(function(option,i){
                        temp.push(option);
                        if(temp.length == 2 || sortedERegOptions.length -1 == i) {
                            groupedERegOptions.push(temp);
                            temp = [];
                        }
                    });
                    console.log("226",sortedERegOptions, groupedERegOptions)
                    ctx.commit('setERegOptions', groupedERegOptions);
                }).fail(function(){
                    ctx.dispatch('addAlert', {type: 'error', message: app.localization.roomReservation.pmsCheckIn.errors.unableToFetchRegOptions})
                }).always(function(){
                    ctx.commit('setShowLoader', false);
                });
            },
            fetchGroupMembers: function(ctx) {
                var fetchGMParams = {
                    CustomerId: app.data.CustomerId,
                    CustomerGUID: app.data.CustomerGUID
                }

                ctx.commit('setShowLoader', true);
                fetchDataFromCache('userModel', 'fetchGroupMembers', fetchGMParams).then(function(res){
                    [].concat(res.GroupMember).forEach(function(gm){
                        gm.displayName = gm.Name.FirstName.concat(' ', gm.Name.LastName)
                        ctx.commit('addGroupMember', gm);
                    });
                }).fail(function(err){
                    console.log(266,err)
                    if(err.Result.ErrorId != "106") //106 means no group members found, in that case no need to throw the error
                    ctx.dispatch('addAlert', {type: 'error', message: app.localization.roomReservation.pmsCheckIn.errors.unableToFetchGroupMembers})
                }).always(function(){
                    ctx.commit('setShowLoader', false);
                })
            },
            createGuestAndAddToShareWith: function(ctx, payloadObj) {
                var newUser = payloadObj.payload;
                var params = {CustomerId: app.data.CustomerId, CustomerGUID: app.data.CustomerGUID}
                
                generateObjectKeyString(newUser, 'NewGroupMember', params);

                ctx.commit('setShowLoader', true);
                $.when(app.models.systemModel.getData('createGroupMember', params)).then(function(res){
                    newUser.displayName = newUser.Name.FirstName.concat(' ', newUser.Name.LastName)
                    newUser.CustomerId = res.NewGroupMemberCustomerId;
                    ctx.commit('addGroupMember', newUser);
                    ctx.commit('addShareWith', newUser);
                    payloadObj.cb();
                }).fail(function(){
                    ctx.dispatch('addAlert', {type: 'error', message: app.localization.newUser.fail})
                }).always(function(){
                    ctx.commit('setShowLoader', false);
                });
            },
            updateFolio: function(ctx, payload) {

                var deferreds = [];

                var updatePMSRegOptionsParams = {
                    FolioId: payload.FolioId,
                    CustomerId: app.data.CustomerId,
                    CustomerGUID: app.data.CustomerGUID,
                    EstimatedArrival: ctx.state.estimatedArrival,
                    SignatureJSON: payload.signature
                }

                var updateCustomerProfileParams = {};

                var shareWithArr = _.values(ctx.state.shareWith).filter(function(shareWith){ return !shareWith.fromFolio });
                generateObjectKeyString(shareWithArr, 'ShareWith', updatePMSRegOptionsParams);

                var eRegOptions = [];
                _.keys(ctx.state.updatedRegOptions).forEach(function(key){
                    if(!ctx.state.existingRegOptions[key]) {
                        eRegOptions.push({Key: key, Value: ctx.state.updatedRegOptions[key]});
                    }
                });
                generateObjectKeyString(eRegOptions, 'ERegOptions.ERegOption', updatePMSRegOptionsParams);

                generateObjectKeyString(ctx.state.customerDetails, 'Customer', updateCustomerProfileParams);

                deferreds.push(app.models.systemModel.getData('updateCustomerProfile', updateCustomerProfileParams));
                deferreds.push(app.models.roomsModel.getData('updatePMSRegOptions', updatePMSRegOptionsParams));
                
                ctx.commit('setShowLoader', true);
                $.when.apply(this, deferreds).then(function(){
                    ctx.commit('setShowLoader', true);
                    app.controllers.initController.initGuestItinerary(['fetchCustomerPMSBookings']).always(function(){
                        ctx.commit('setShowLoader', false);
                        app.dispatcher.redirect('summary');
                    });
                }).fail(function(err){
                    ctx.dispatch('addAlert', {type: 'error', message: err.Result.Text, scrollIntoView: true})
                }).always(function(){
                    ctx.commit('setShowLoader', false);
                });
            },
            fetchFolioData: function(ctx, payload) {
                var pmsParams = {
                    CustomerId: app.data.CustomerId,
                    CustomerGUID: app.data.CustomerGUID,
                    BookStatus: "RESERV",
                    PMSFolioId: payload.folioId
                }

                ctx.commit('setShowLoader', true);
                fetchDataFromCache('userModel', 'fetchCustomerPMSBookings', pmsParams).then(function(res){
                    var booking =  res.PMSBooking[0]
                    booking.numOfGuests = +booking.NumAdults + +booking.NumChildren + +booking.NumYouth
                    ctx.commit('setPmsBooking', booking);
                    ctx.commit('setDailyRates', [].concat(booking.DailyRateDetails.DailyRateDetail));

                    ((booking.Guests || {}).Guest || []).forEach(function(guest){
                        guest.displayName = guest.FirstName.concat(' ', guest.LastName);
                        guest.fromFolio = true;
                        ctx.commit('addShareWith', guest);
                    });

                    var existingRegOptions = {};
                    
                    [].concat((booking.ERegOptions || {}).ERegOption || []).forEach(function(eRegOption){
                        if(!eRegOption.Key) return;
                        
                        existingRegOptions[eRegOption.Key] = eRegOption.Value;
                    });

                    ctx.commit('setExistingRegOptions', existingRegOptions);
                    ctx.commit('setPossibleArrivalTimes')

                    if(payload.cb) payload.cb(existingRegOptions);

                    //fetch venues
                    var selectedVenue = ctx.state.venueDetails
                    fetchDataFromCache('roomsModel', 'pmsVenues').always(function(venues) {
                        var dateAndTime = ctx.state.arrivalTimes.length && ctx.state.arrivalTimes[0].value || '' //default to the first in list;
                        if(venues.Venue && venues.Venue.length){
                            _.each(venues.Venue,function(location){
                                if(!_.isEmpty(selectedVenue) && location.VenueId === selectedVenue.Venue){
                                var arrivalDate = ctx.state.pmsBookingInfo.ArrivalDate.toString().substring(0,10)
                                    dateAndTime = arrivalDate && arrivalDate.concat(location.CheckInTime)        
                                }                           
                            })
                        }
                        ctx.commit('setEstimatedArrival', dateAndTime)

                    })
                }).fail(function(){
                    ctx.dispatch('addAlert', {type: 'error', message: app.localization.roomReservation.pmsCheckIn.errors.unableToPmsBookings})
                }).always(function(){
                    ctx.commit('setShowLoader', false);
                });
            },
            
            fetchCustomerDetails: function(ctx, payload) {
                ctx.commit('setShowLoader', true);
                $.when(app.models.userModel.getData('fetchCustomerProfile', payload.params)).then(function(res){
                    if(payload.cb) payload.cb(res);
                }).fail(function(){
                    ctx.dispatch('addAlert', {type: 'error', message: app.localization.roomReservation.pmsCheckIn.errors.unableToCustomerProfile})
                }).always(function(){
                    ctx.commit('setShowLoader', false);
                });
            }
        }
    } 
    
});
